import React, { Component } from 'react'

import Videos from '../components/videos'

import $ from 'jquery'

const LINKS = [
  {
    title: 'Kurzdokumentation',
    subtitle: '',
    url: 'Z8bgdqRSaAQ'
  },
  {
    title: 'Kurzdokumentation mit arabischen Untertiteln',
    subtitle: 'المقطع العارض لمشروع (الذاكرة في المستقبل) مترجم',
    url: 'jVsPaQEAi08'
  },
  {
    title: 'Interview Dr. Thomas Würtz',
    subtitle: '',
    url: 'gpi-Mn89UKg'
  },
  {
    title: 'Interview mit Marie von Manteuffel',
    subtitle: '',
    url: 'shOCzI6jLWo'
  }
]

export default class VideosPage extends Component {
  componentDidMount() {
    if ($('.Videos')) {
      $('html, body').animate(
        { scrollTop: $('.Videos').offset().top - 83 },
        1000
      )
    }
  }

  componentDidUpdate() {
    if ($('.Videos')) {
      $('html, body').animate(
        { scrollTop: $('.Videos').offset().top - 83 },
        1000
      )
    }
  }

  render() {
    return (
      <div className="Videos">
        <Videos links={LINKS} />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/videospage.js
 **/